<template>
  <v-menu close-on-content-click open-on-hover location="right top" width="220px">
    <template #activator="{ props }">
      <v-list-item :disabled="openRecentsMenuDisabled()" v-bind="props" @click.stop>
        <div class="d-flex justify-space-between">
          <v-list-item-title>Open Recent</v-list-item-title>
          <v-icon>mdi-chevron-right</v-icon>
        </div>
      </v-list-item>
    </template>
    <v-list v-if="loading && !openRecentsMenuDisabled()" density="compact">
      <v-list-item class="d-flex justify-center align-center"
        ><v-progress-circular indeterminate color="primary"></v-progress-circular
      ></v-list-item>
    </v-list>
    <v-list v-else-if="!openRecentsMenuDisabled()" width="220px" density="compact">
      <div v-for="(item, index) in recentItems" :key="`recent-${index}`">
        <v-list-item class="pr-4 py-0" @click="openStatechart(item.model)">
          <div class="d-flex justify-start" style="gap: 10px">
            <v-icon>mdi-cloud-outline</v-icon>
            <v-list-item-title>{{ item.model.title || "No Title" }}</v-list-item-title>
          </div>
        </v-list-item>
      </div>
      <v-divider v-if="moreStatecharts"></v-divider>
      <v-list-item v-if="moreStatecharts" class="pr-4 py-0" @click="$emit('openStatechartWizard')">
        <div class="d-flex justify-start" style="gap: 10px">
          <v-icon>mdi-dots-horizontal</v-icon>
          <v-list-item-title>Show all</v-list-item-title>
        </div>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import { ref, inject, onMounted } from "vue";
import RecentItemsService, { RecentFile } from "../../../services/storage/recent-items-service";
import { ModelData } from "../../../services/statecharts/ModelData";
import { loadStatechart } from "../../../utils/loadStatechart";
import ModelLoader from "../../../services/model-loader";
import { StatechartsService } from "../../../services/statecharts/statecharts-service";
import { MessageEventBus, ProgressBarEventBus } from "../../../../event-bus";
import { CodeSimulationService } from "../../../services/simulation/code/simulation-service-code";

const emit = defineEmits(["closeFileMenu", "openStatechartWizard"]);

const recentItems = ref<RecentFile[]>([]);
const moreStatecharts = ref(false);
const loading = ref(true);

const recentItemsService: RecentItemsService = inject<RecentItemsService>("recentItemsService");
const simulationControl: CodeSimulationService = inject<CodeSimulationService>("simulationControl");
const modelLoader: ModelLoader = inject<ModelLoader>("modelLoader");
const cloudStatechartService: StatechartsService = inject<StatechartsService>("cloudStatechartService");

onMounted(async () => {
  await recentItemsService
    .getRecentFilesList()
    .then((res) => {
      recentItems.value = res.lastFive;
      moreStatecharts.value = res.all.length > res.lastFive.length;
      loading.value = false;
    })
    .catch(() => {
      loading.value = false;
    });
});

function openRecentsMenuDisabled(): boolean {
  return recentItems.value.length === 0 && !loading.value;
}

async function openStatechart(stc: ModelData) {
  ProgressBarEventBus.emit("startTask");
  emit("closeFileMenu");
  try {
    const model = await cloudStatechartService.getModel(stc.id);
    loadStatechart(simulationControl, modelLoader, model, stc.id, "'" + stc.title + "' opened!");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    let errMsg = "Statechart could not be opened.";
    if (typeof err === "string") errMsg = err;
    ProgressBarEventBus.emit("finishedTask");
    MessageEventBus.emit("error", {
      text: errMsg,
      id: "open-statechart",
    });
  }
}
</script>
